import cx from 'classnames'
import s from './style.module.scss'

interface IPreloaderSmallProps {
  size?: 'sm' | 'md'
  color?: 'white'
  className?: string
}

const PreloaderSmall = ({ size, className, color }: IPreloaderSmallProps) => {
  const classNames = cx(
    s['preloader-small'],
    {
      [s[`size-${size}`]]: size,
      [s[`color-${color}`]]: color
    },
    className
  )

  return <div className={classNames} />
}

export default PreloaderSmall
